const en = {
  locale: 'en',
  Navbar: {
    home: 'Home',
    about: 'About Me',
    tech: 'Technologies',
    certificates: 'Certificates',
    projects: 'Projects',
    contact: "Let's Connect",
  },
  Hero: {
    title: "Hi, I'm Raul",
    greeting:
      "A software developer based in Deltona, FL, creating seamless digital experiences. Explore my work and let's discuss your project!",
    role: 'Software Developer',
    button: 'Pr',
    button_two: 'oje',
    button_three: 'cts',
    stat_years: 'Years Building',
    stat_stack_title: 'Full Stack',
    stat_stack_copy: 'Web and SaaS',
    stat_ios_copy: 'SwiftUI Apps',
    location_label: 'Based in Florida',
    profile_copy:
      'Building calm, modern products with strong UX, scalable architecture, and production-ready detail.',
  },
  AboutMe: {
    title: 'About Me',
    headline: 'Building thoughtful digital products across web and mobile.',
    experience_label: 'Years shipping production code',
    panel_one_title: 'Frontend & Backend',
    panel_two_title: 'Data & Integrations',
    panel_three_title: 'Craft & Curiosity',
    one: 'I am a full-stack developer with over 5 years of experience creating modern, scalable web applications and SaaS platforms. My expertise includes building intuitive front-end interfaces with ',
    front_end: 'React, Next.js, Tailwind CSS, and SwiftUI, ',
    one_middle: 'as well as developing robust back-end systems with ',
    back_end: 'Spring Boot, Node.js, Express, and Supabase',
    two: 'I specialize in integrating powerful technologies like ',
    data_base: 'PostgreSQL, MongoDB, MySQL, OpenAI API, and Mapbox API ',
    two_middle:
      'to create seamless user experiences. With a strong focus on efficiency and scalability, I leverage tools such as ',
    version_control: 'Docker, AWS, Git, and Stripe ',
    two_final: 'to streamline workflows, deployment, and payments.',
    three:
      'Driven by curiosity and a commitment to excellence, I am passionate about delivering impactful digital solutions, building both web and mobile experiences, and continuously improving my skills.',
  },
  Technologies: {
    title: 'Technologies',
    sub_title: 'This is a collection of technologies I have worked with.',
    headline:
      'A toolkit built for shipping complete products, not just mockups.',
    front_end: 'Front-End',
    languages: 'Programming Languages',
    languages_sub: 'Languages I code in',
    front_end_sub: 'Frontend tech used in my projects',
    back_end: 'Back-End',
    back_end_sub: 'Backend tech used in my projects',
    tools: 'Tools and APIs',
    tools_sub: 'Tools and APIs used in my projects',
  },
  Certificates: {
    title: 'Certificates',
    subtitle: "Here are some of the certificates I've earned.",
    headline:
      'Professional growth backed by hands-on learning and shipping real work.',
    button: 'View Certificate',
  },
  Projects: {
    title: 'Projects',
    sub_title: "Here are some of the projects I've worked on.",
    headline:
      'Selected work that combines product thinking, strong UI, and clean engineering.',
    featured: 'Featured Project',
    infojobs:
      "InfoJobs landing page designed to showcase the platform's features and benefits, making job searches easier and more efficient while engaging users with a modern and intuitive experience.",
    nextil:
      'Nextil is an all-in-one appointment scheduling and business management platform designed for barbershops, salons, and beauty professionals. It enables businesses to manage appointments, clients, services, staff availability, and earnings, while offering online booking, multilingual support, and mobile access.',
    connectme:
      'ConnectME is a social media application that allows users to create an account, make posts, and interact with other users. It is built using the MERN stack.',
    bookme:
      'BookNow is a platform empowering salon and barbershop owners to elevate their business. It offers online appointment booking and management for customers.',
    propet:
      'ProPet is an online store that allows buyers to log in, browse through multiple categories of pets, select favorite products, add them to the cart, and complete the purchase.',
    ims: 'This Inventory Management System application allows companies with a large number of products to efficiently manage and track their inventory.',
    tech: 'Technologies',
    live: 'Demo',
    source: 'Source Code',
  },
  IOS: {
    title: 'iOS Apps',
    subtitle: "Here are some of the iOS apps I've developed.",
    headline:
      'Native iPhone apps designed with the same attention to clarity and detail.',
    native: 'Native iOS',
    store: 'App Store',
    trackmiles_description:
      'Effortlessly manage your mileage with TrackMiles, the intuitive app designed for seamless tracking and organization. Record, review, and gain insights into your travel activities with ease. From real-time trip statistics to detailed mileage reports, TrackMiles offers a powerful yet simple solution for all your mileage tracking needs.',
    bodytrack_description:
      'BodyTrack is a comprehensive fitness app that helps you monitor your health by tracking calories, steps, water intake, and workouts. Integrated with HealthKit and MapKit, it offers personalized goal-setting, a detailed dashboard, smart reminders, and workout route tracking all without the need for extra devices. Enjoy all core features for free with ads, and opt for an ad-free experience via subscription.',
    nextil_ios_description:
      'Nextil is a native iOS app built with SwiftUI that enables businesses such as barbershops and salons to manage appointments, clients, availability, and earnings on the go. The app integrates with Supabase for the backend, Mapbox for location and maps, and Stripe for payments, delivering a fast, modern, and productivity-focused experience.',
    tech: 'Technologies',
  },
  MacOS: {
    title: 'macOS Apps',
    subtitle: "Here are some of the Mac apps I've developed.",
    headline:
      'Native Mac apps that make everyday workflows faster and simpler.',
    native: 'Native macOS',
    download: 'Download',
    imageoptimizer_description:
      'Image Optimizer is a native Mac app that turns photos into small, web-ready WebP files at the exact size or quality you choose. It handles crop presets, desktop and mobile versions, and a before/after preview, and it names each image and writes alt text from what is in the picture. Version 1.3 uses Apple Intelligence, the AI built into macOS, so it works with nothing to install and images never leave the Mac, with Apple Vision and local Ollama models as alternatives.',
  },
  Connect: {
    title: "Let's Connect",
    headline: 'Open to new collaborations, product work, and ambitious ideas.',
    subtitle:
      'I am always open to discussing new projects, creative ideas or opportunities to be part of your vision.',
    cta: 'Explore',
    email: 'Email',
    linkedin: 'LinkedIn',
    github: 'GitHub',
  },
  Footer: {
    copyright: 'Copyright 2025 - 2026. All rights reserved.',
  },
};

export default en;
